/* istanbul ignore file */
import React from 'react';
import { OneStopButtonsLayout } from 'domain/shared/oneStop';

type InstantFeedbackLayoutProps = {
  isFixedButtons?: boolean;
  children: React.ReactElement;
  headerRight?: React.ReactElement;
  handleCancelClick?: Nullable<() => void>;
};

const InstantFeedbackLayout = ({
  children,
  headerRight,
  isFixedButtons = true,
  handleCancelClick,
}: InstantFeedbackLayoutProps) => {
  const Title = () => {
    return <div>{headerRight}</div>;
  };

  return (
    <>
      <Title />
      {children}
      <OneStopButtonsLayout onCancelAction={handleCancelClick} isFixed={isFixedButtons} />
    </>
  );
};

export default InstantFeedbackLayout;
